<template>
  <footer id="footer" class="pt-5">
    <Holder :holder="getPageDataHolder(section, 'Obsah')"></Holder>
    <LazyLoginModal/>
    <ClientOnly>
      <LazyCookiesModal/>
    </ClientOnly>
  </footer>
</template>

<script setup lang="ts">
import {onMounted, PropType, ref} from "vue";
import {PageSection} from "~/lib/interfaces/model/PageSection";
import Holder from "~/components/Holder.vue"
import {getPageDataHolder} from "~/composables/master_page";
import {useNuxtApp, useState} from "#app";
import {resolveComponent} from "#imports";
import Page from "../../../lib/models/Page";

const LazyCookiesModal = resolveComponent("LazySectionCookiesModal");
const LazyLoginModal = resolveComponent("LazyPartsLoginModal");
const fPreloadInterval = ref<null | number>(null);
const props = defineProps({
  page: Page,
  section: Object as PropType<PageSection>
})

const {$i18n} = useNuxtApp();
onMounted(() => {
  fPreloadInterval.value = setInterval(() => {
    if (useState('first_preload').value) {
      useState('first_preload').value = false;
    } else {
      fPreloadInterval.value = null;
      clearInterval(fPreloadInterval.value);
    }
  }, 50);
});

</script>
